import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import QRCode from 'qrcode';
import { JOB_FAIR_CONFIG } from '../../constants/jobFairIntro';
import {
  checkJDPermissionsService,
  fetchJDDataService,
  deleteJDService,
  getJDByIdService,
  updateJDStatusService,
  generateShareableLinkService,
} from '../../Services/viewCreatedJDs.service';
import '../../css/orgadmin.css';
import ConfirmationDialog from './ConfirmationDialog';
import Pagination from './Pagination';
import { QR_CODE_OPTIONS } from '../../constants/secondaryCamera';

import {
  PlusCircle,
  Settings,
  MoreVertical,
  SlidersHorizontal,
  Upload,
  X,
  XCircleIcon,
  FileDown,
  Layout,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
  ArrowUpAZ,
  ArrowDownZA,
  CircleX,
  ChevronsLeft,
  ChevronsRight,
  Download,
  UserRoundPlus,
  Trash2,
  XIcon,
  ChevronDown
} from 'lucide-react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Loader from '../Loader';
import * as XLSX from 'xlsx';
import PlatformCalendar from './platformCalendar';
import { useTheme } from '../../hooks/useTheme';
import { calendarOverrideStyles } from './datePickerStyles';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateActiveTab,
  updateNavigationTab,
} from '../../store/slices/candidateManagementSlice';
import { updateCurrentJobRole } from '../../store/slices/filterOptionsSlice';
import {
  setStatusFilter as setReduxStatusFilter,
  resetStatusFilter,
} from '../../store/slices/viewCreatedJdsSlice';
import { getJobDescriptionThunk } from '../../store/thunks/InterviewThunk';
import { toggleisjdcreated } from '../../store/slices/miscSlice';
import HelpVideoModal from './HelpVideoModal';
import { HELP_VIDEOS } from '../../config/helpVideos';

const CreatedJDs = () => {
  const [jobDescriptions, setJobDescriptions] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const urlPage = parseInt(searchParams.get('page')) || 1;
  const [currentPage, setCurrentPage] = useState(urlPage);
  const [showEditJDForm, setShowEditJDForm] = useState(false);
  const [jobRole, setJobRole] = useState('');
  const [jobdesc, setJobdesc] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isHelpVideoOpen, setIsHelpVideoOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const portal = location.pathname.startsWith('/hr') ? 'hr' : 'org-admin';
  const [jd_id, setjd_id] = useState('');
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [jobStatuses, setJobStatuses] = useState({});
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [statusFilter, setStatusFilter] = useState(
    location.state?.statusFilter || 'All',
  );
  const [tempStatusFilter, setTempStatusFilter] = useState(
    location.state?.statusFilter || 'All',
  );
  const [jobTypeFilter, setJobTypeFilter] = useState('All');
  const [tempJobTypeFilter, setTempJobTypeFilter] = useState('All');
  const [allSkills, setAllSkills] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [tempDateRange, setTempDateRange] = useState([null, null]);
  const [expRange, setExpRange] = useState({ min: '', max: '' });
  const [tempExpRange, setTempExpRange] = useState({ min: '', max: '' });
  const [sortOrder, setSortOrder] = useState(null);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showColumnSelector, setShowColumnSelector] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    jobRole: true,
    jobType: true,
    createdDate: true,
    experienceRange: true,
    // validUntil: true,
    action: true,
  });
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [selectedJobForInvite, setSelectedJobForInvite] = useState(null);
  const [shareableLink, setShareableLink] = useState('');
  const [linkExpiryDate, setLinkExpiryDate] = useState(null);
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const filterRef = useRef(null);
  const calendarRef = useRef(null);
  const columnSelectorRef = useRef(null);
  const topRef = useRef(null);
  // const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showJDViewModal, setShowJDViewModal] = useState(false);
  const [isLoadingJDDetails, setIsLoadingJDDetails] = useState(false);
  const [selectedJDForView, setSelectedJDForView] = useState(null);
  const [dropdownMenuDirection, setDropdownMenuDirection] = useState({}); // { jd_id: 'up' | 'down' }
  const maxPageButtons = 5;
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [selectedJDForDelete, setSelectedJDForDelete] = useState(null);
  const [atsSubdomain, setAtsSubdomain] = useState(null);
  const [jobFairIntroEnabled, setJobFairIntroEnabled] = useState(false);
  const [atsEnabled, setAtsEnabled] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const dispatch = useDispatch();
  const { theme } = useTheme();
  const reduxStatusFilter = useSelector(
    (state) => state.viewCreatedJds.statusFilter,
  );
  const isjdcreated = useSelector((state) => state.miscSlice.isjdcreated);

  //To show toaster only when landed from create/edit JD page with success message
   useEffect(() => {

    if (isjdcreated && location.state?.showSuccessToast) {
      const timer = setTimeout(() => {
        toast.success('Job role created successfully!');
        dispatch(toggleisjdcreated(false));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);


  // Sync Redux filter with local state
  useEffect(() => {
    if (reduxStatusFilter && reduxStatusFilter !== 'All') {
      setStatusFilter(reduxStatusFilter);
      setTempStatusFilter(reduxStatusFilter);
    }
  }, [reduxStatusFilter]);

  // Reset Redux filter when component unmounts to avoid stale filters on next direct visit
  useEffect(() => {
    return () => {
      dispatch(resetStatusFilter());
    };
  }, [dispatch]);

  useEffect(() => {
    const checkAdminAuthorization = async () => {
      try {
        const data = await checkJDPermissionsService();
        setAtsEnabled(data.ats_enabled);
      } catch (error) {
        console.error('Error checking admin ID:', error);
        if (error.response) {
          const { status, data } = error.response;
          if (status === 401) {
            toast.error('Unauthorized: Invalid token');
            sessionStorage.removeItem('accessToken');
          } else {
            toast.error(
              `Error: ${data.detail || 'Failed to check admin status'}`,
            );
          }
        } else {
          toast.error('Network error: Unable to reach the server');
        }
        setAtsEnabled(false);
      }
    };

    checkAdminAuthorization();
  }, []);

  useEffect(() => {
    if (currentPage !== urlPage) {
      if (currentPage === 1) {
        searchParams.delete('page');
        setSearchParams(searchParams);
      } else {
        setSearchParams({ page: currentPage.toString() });
      }
    }
  }, [currentPage, urlPage, searchParams, setSearchParams]);

  // Filtering and sorting logic
  useEffect(() => {
    const filtered = jobDescriptions.filter((job) => {
      const matchesSearch = job.jobrole
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const jobStatus = jobStatuses[job.jd_id] || job.jd_status || 'Active';
      const matchesStatus =
        statusFilter === 'All' || jobStatus === statusFilter;
      const matchesJobType =
        jobTypeFilter === 'All' ||
        job.jd_version === jobTypeFilter;
      let matchesBuilder = true;
      matchesBuilder =
        job.jobDescriptionType === 'classic' ||
        (job.jobDescriptionType === 'customized' &&
          (job.status === 'finalized' || job.jd_status === 'finalized'));

      let matchesDate = true;
      if (dateRange[0] || dateRange[1]) {
        const jobDate = new Date(job.postingDate);
        const startDate = dateRange[0] ? new Date(dateRange[0]) : null;
        const endDate = dateRange[1] ? new Date(dateRange[1]) : null;
        if (startDate && jobDate < startDate) matchesDate = false;
        if (endDate) {
          endDate.setHours(23, 59, 59, 999);
          if (jobDate > endDate) matchesDate = false;
        }
      }

      let matchesExp = true;
      if (expRange.min || expRange.max) {
        const minExp = Number(job.description?.minExp ?? -1);
        const maxExp = Number(job.description?.maxExp ?? -1);
        const filterMin = expRange.min ? parseFloat(expRange.min) : null;
        const filterMax = expRange.max ? parseFloat(expRange.max) : null;

        if (minExp === -1 || maxExp === -1) {
          matchesExp = false;
        } else {
          if (filterMin !== null && filterMax !== null) {
            matchesExp =
              minExp >= filterMin && maxExp <= filterMax && minExp <= maxExp;
          } else {
            matchesExp = false;
          }
        }
      }

      return (
        matchesSearch &&
        matchesStatus &&
        matchesJobType &&
        matchesBuilder &&
        matchesDate &&
        matchesExp
      );
    });

    const sortedJobs = [...filtered].sort((a, b) => {
      const roleA = a.jobrole.toLowerCase();
      const roleB = b.jobrole.toLowerCase();
      if (!sortOrder) {
        const dateB = new Date(b.postingDate);
        const dateA = new Date(a.postingDate);
        if (dateB - dateA !== 0) {
          return dateB - dateA;
        }
        // Fallback: If dates are identical, sort by jd_id descending to show the absolute latest job first
        return String(b.jd_id).localeCompare(String(a.jd_id), undefined, { numeric: true });
      }
      if (sortOrder === 'A-Z') {
        return roleA < roleB ? -1 : roleA > roleB ? 1 : 0;
      } else if (sortOrder === 'Z-A') {
        return roleA > roleB ? -1 : roleA < roleB ? 1 : 0;
      }
      return 0;
    });

    setFilteredJobs(sortedJobs);
    // setCurrentPage(1); // Reset to first page when filters change
    // setSearchParams({ page: "1" });
  }, [
    searchQuery,
    jobDescriptions,
    statusFilter,
    jobStatuses,
    dateRange,
    expRange,
    sortOrder,
    jobTypeFilter,
  ]);

  const totalItems = filteredJobs.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setSearchParams({ page: pageNumber.toString() });
      topRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getPageRange = () => {
    const halfMaxButtons = Math.floor(maxPageButtons / 2);
    let start = Math.max(1, currentPage - halfMaxButtons);
    let end = Math.min(totalPages, start + maxPageButtons - 1);

    if (end === totalPages) {
      start = Math.max(1, end - maxPageButtons + 1);
    }

    const range = [];
    for (let i = start; i <= end; i++) {
      range.push(i);
    }
    return range;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !calendarRef.current?.contains(event.target)
      ) {
        setShowFilterDropdown(false);
        setIsCalendarOpen(false);
      }
      if (
        activeDropdown &&
        !event.target.closest('.dropdown-button') &&
        !event.target.closest('.dropdown-menu')
      ) {
        setActiveDropdown(null);
      }
      if (
        columnSelectorRef.current &&
        !columnSelectorRef.current.contains(event.target)
      ) {
        setShowColumnSelector(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [
    activeDropdown,
    showFilterDropdown,
    showColumnSelector,
    isCalendarOpen,
  ]);

  const handleEditAssessment = (job) => {
    // if (portal === 'org-admin') {
    if (job.jobDescriptionType === 'customized') {
      navigate(`/org-admin/create-jd-custom?id=${job.jd_id}&mode=builder&isEditFlow=true`);
    } else {
      navigate('/org-admin/create-jd-smart', {
        state: {
          jd_id: job.jd_id,
          jobRole: job.jobrole,
          mode: 'view-rounds',
          isEditFlow: true,
        },
      });
      //   }
      // } else if (portal === 'hr') {
      //   if (job.jobDescriptionType === "customized") {
      //     navigate(`/hr/create-jd-custom?id=${job.jd_id}&mode=builder&readonly=true`);
      //   } else {
      //     navigate("/hr/create-jd-smart", {
      //       state: {
      //         jd_id: job.jd_id,
      //         jobRole: job.jobrole,
      //         mode: 'view-rounds',
      //         readonly: true
      //       },
      //     });
      //   }
    }
  };

  const handleUploadResume = (jdId) => {
    navigate('/org-admin/checkresume', {
      state: {
        selectedJobId: jdId,
        autoSelectJob: true,
      },
    });
    setShowEditJDForm(false);
  };

  const fetchCombinedData = async () => {
    try {
      setIsLoading(true);

      const data = await fetchJDDataService();
      const filteredJobs = data?.job_descriptions.filter(
        (job) => !job.status || job.status !== 'draft',
      );
      setJobDescriptions(filteredJobs);
      const initialStatuses = {};
      filteredJobs.forEach((job) => {
        initialStatuses[job.jd_id] = job.jd_status || 'Active';
      });
      setJobStatuses(initialStatuses);

      setAtsSubdomain(data?.ats_subdomain || null);
      setJobFairIntroEnabled(Boolean(data?.job_fair_intro_enabled));
    } catch (error) {
      toast.error('An unexpected error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCombinedData();
  }, []);

  const handleAddJD = () => {
    navigate(`/org-admin/jd-selection`);
  };

  const handleDeleteConfirmation = (e, jd) => {
    e.stopPropagation();
    setSelectedJDForDelete(jd);
    setShowDeleteConfirmDialog(true);
  };

  const confirmDeleteJD = () => {
    if (selectedJDForDelete) {
      handleDeleteJD({ preventDefault: () => {} }, selectedJDForDelete.jd_id);
    }
  };

  const handleDeleteJD = async (e, jd_id) => {
    e.preventDefault();

    try {
      const response = await deleteJDService(jd_id);
      if (response.status === 200) {
        toast.success('Job Description Deleted Successfully!');
        await fetchCombinedData();
        setShowEditJDForm(false);
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem('accessToken');
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    } finally {
      setShowDeleteConfirmDialog(false);
    }
  };

  const handleEditJDRequest = async (jdId) => {
    try {
      const data = await getJDByIdService(jdId);
      setShowEditJDForm(true);
      if (data) {
        setjd_id(jdId);
        setJobRole(data.jobrole);
        setJobdesc(data.description);

        if (data.description.jobDescriptionType === 'customized') {
          console.log('Loading GUIDED Job Description format');
          const skillBasedData =
            data.description.Required_Skills?.skill_based || [];
          const allSkills = skillBasedData.flatMap((skill) => {
            return [skill.skill_name, ...(skill.topics || [])];
          });
          setAllSkills(allSkills);
        } else {
          setAllSkills([]);
        }
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem('accessToken');
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  };

  const handleNavigate = async (job) => {
    dispatch(updateActiveTab('SOURCED'));
    dispatch(updateNavigationTab('ALL'));
    dispatch(getJobDescriptionThunk(job.jd_id));
    console.log({ job });
    dispatch(updateCurrentJobRole(job.jobrole || 'All'));
    const slug = job.jobrole.replace(/\s+/g, '-');
    if (location.pathname === '/hr/jobvacancies') {
      navigate('/hr/schedule-interview');
    } else {
      navigate(`/org-admin/jobs/${slug}`);
    }
  };

  const handleViewCandidates = (jobId, selectedServices, jobrole) => {
    const services = Object.keys(selectedServices).filter(
      (service) => selectedServices[service],
    );
    navigate(`/org-admin/candidatelist`, {
      state: { jobId: jobId, services: services, jobrole: jobrole },
    });
  };

  const updateJobStatus = async (jdId, newStatus) => {
    try {
      const response = await updateJDStatusService(jdId, newStatus);
      if (response.status === 200) {
        setJobStatuses((prev) => ({
          ...prev,
          [jdId]: newStatus,
        }));
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem('accessToken');
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  };

  const formatJobDescription = (jobrole, data) => {
    if (data.Required_Skills?.skill_based) {
      const skillBasedData = data.Required_Skills?.skill_based || [];
      const skillsDisplay = skillBasedData
        .map((skill) => {
          const topics =
            skill.topics && skill.topics.length > 0
              ? ` (${skill.topics.join(', ')})`
              : '';
          return `• ${skill.skill_name}${topics}`;
        })
        .join('\n');

      return (
        <pre className="font-sans glass-effect text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner text-white">
          {`Position: ${jobrole}\nExperience Range: ${data.minExp || 0} - ${
            data.maxExp || 1
          } years\n\nRequired Skills:\n${skillsDisplay || '- None'}\n\n${
            data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                  (item, i) => `${i + 1}. ${item}`,
                ).join('\n')}`
              : ''
          }\n\n${
            data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                  ', ',
                )}\n\n`
              : ''
          }${
            data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(', ')}\n\n`
              : ''
          }`}
        </pre>
      );
    } else {
      const experience = (data.minExp + data.maxExp) / 2;
      return (
        <pre className="font-sans glass-effect text-md whitespace-pre-wrap break-words p-6 rounded-2xl max-h-[70vh] overflow-y-auto shadow-inner text-white">
          {`Position: ${jobrole}\nExperience Range: ${data.minExp} - ${
            data.maxExp
          } years \n\nRequired Skills:\n${
            experience < 4
              ? data.Required_Skills?.Medium?.length
                ? data.Required_Skills.Medium.map(
                    (skill, i) => `${i + 1}. ${skill}`,
                  ).join('\n')
                : '- None'
              : data.Required_Skills?.Hard?.length
                ? data.Required_Skills.Hard.map(
                    (skill, i) => `${i + 1}. ${skill}`,
                  ).join('\n')
                : '- None'
          }\n\nOptional Skills:\n${
            experience < 4
              ? data.Required_Skills?.Easy?.join(', ') || 'None'
              : data.Required_Skills?.Medium?.join(', ') || 'None'
          }\n\n${
            data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                  (item, i) => `${i + 1}. ${item}`,
                ).join('\n')}`
              : ''
          }\n\n${
            data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                  ', ',
                )}\n\n`
              : ''
          }${
            data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(', ')}\n\n`
              : ''
          }`}
        </pre>
      );
    }
  };

  const toggleDropdown = (id) => {
    if (activeDropdown === id) {
      setActiveDropdown(null);
      return;
    }

    const buttonElement = document.getElementById(`dropdown-button-${id}`);
    let direction = 'down';

    if (buttonElement) {
      const buttonRect = buttonElement.getBoundingClientRect();
      const dropdownHeightEstimate = 180; // Estimated height of the menu

      // Calculate space relative to the scrollable container and viewport
      const scrollContainer = buttonElement.closest('.overflow-y-auto');
      const containerRect = scrollContainer
        ? scrollContainer.getBoundingClientRect()
        : { bottom: window.innerHeight, top: 0 };

      const viewportBottom = window.innerHeight;
      const viewportTop = 0;

      // Available space below (within container and viewport)
      const spaceBelow = Math.min(containerRect.bottom, viewportBottom) - buttonRect.bottom;
      // Available space above (within container and viewport)
      const spaceAbove = buttonRect.top - Math.max(containerRect.top, viewportTop);

      // Prefer "down" if there's enough space, otherwise go "up" if it has more space
      if (spaceBelow < dropdownHeightEstimate && spaceAbove > spaceBelow) {
        direction = 'up';
      }
    }

    setDropdownMenuDirection((prev) => ({ ...prev, [id]: direction }));
    setActiveDropdown(id);
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case 'On Hold':
        return 'bg-amber-500 hover:bg-amber-600';
      case 'Closed':
        return 'bg-red-500 hover:bg-red-600';
      default:
        return 'bg-green-500 hover:bg-green-600';
    }
  };

  const getStatusCounts = () => {
    const counts = {
      All: jobDescriptions.length,
      Active: 0,
      'On Hold': 0,
      Closed: 0,
    };

    const validStatuses = ['Active', 'On Hold', 'Closed'];

    jobDescriptions.forEach((job) => {
      let rawStatus = jobStatuses[job.jd_id] || job.jd_status || 'Active';
      let status = rawStatus.trim();

      if (!validStatuses.includes(status)) {
        status = 'Active';
      }

      counts[status]++;
    });

    return counts;
  };

  const statusCounts = getStatusCounts();

  const handleDateRangeChange = (value) => {
    setTempDateRange(value);
  };

  const handleExpRangeChange = (e, type) => {
    const value = e.target.value;
    setTempExpRange((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleStatusSelect = (status) => {
    setTempStatusFilter(status);
  };

  const handleResetFilter = () => {
    setShowFilterDropdown(false);
    setTempJobTypeFilter('All');
    setJobTypeFilter('All');
    setTempStatusFilter('All');
    setTempDateRange([null, null]);
    setTempExpRange({ min: '', max: '' });
    setSearchQuery('');
    setStatusFilter('All');
    setDateRange([null, null]);
    setExpRange({ min: '', max: '' });
  };

  const handleResetJobType = () => {
    setTempJobTypeFilter('All');
    setJobTypeFilter('All');
  };

  const handleResetStatus = () => {
    setTempStatusFilter('All');
    setStatusFilter('All');
  };

  const handleResetDateRange = () => {
    setTempDateRange([null, null]);
    setDateRange([null, null]);
  };

  const handleResetExpRange = () => {
    setTempExpRange({ min: '', max: '' });
    setExpRange({ min: '', max: '' });
  };

  const formatDateRange = (range) => {
    if (!range[0] || !range[1]) return 'Select Date Range';
    return `${range[0].toLocaleDateString()} to ${range[1].toLocaleDateString()}`;
  };

  const activeFilters = [];
  // if (searchQuery) {
  //   activeFilters.push({
  //     label: `Search: ${searchQuery}`,
  //     onRemove: () => setSearchQuery(""),
  //   });
  // }
  if (statusFilter !== 'All') {
    activeFilters.push({
      label: `Status: ${statusFilter}`,
      onRemove: handleResetStatus,
    });
  }
  if (jobTypeFilter !== 'All') {
    activeFilters.push({
      label: `Job Type: ${jobTypeFilter}`,
      onRemove: handleResetJobType,
    });
  }
  if (dateRange[0] || dateRange[1]) {
    activeFilters.push({
      label: `Date: ${formatDateRange(dateRange)}`,
      onRemove: handleResetDateRange,
    });
  }
  if (expRange.min || expRange.max) {
    activeFilters.push({
      label: `Experience: ${expRange.min || '0'} - ${
        expRange.max || 'N/A'
      } yrs`,
      onRemove: handleResetExpRange,
    });
  }
  const filterCount = activeFilters.length;

  const handleApplyFilters = () => {
    setStatusFilter(tempStatusFilter);
    setJobTypeFilter(tempJobTypeFilter);
    setDateRange(tempDateRange);
    setExpRange(tempExpRange);
    setShowFilterDropdown(false);
    topRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleDownloadExcel = () => {
    if (!filteredJobs.length) {
      toast.warning('No job descriptions to export.');
      return;
    }
    const excelData = filteredJobs.map((jd) => {
      const data = {};
      if (visibleColumns.jobRole) {
        data['Job Role'] = jd.jobrole;
      }
      if (visibleColumns.jobType) {
        data['Job Type'] = jd.jd_version === 'Smart Mode' ? 'Smart' : jd.jd_version === 'Custom Mode' ? 'Custom' : jd.jd_version;
      }
      if (visibleColumns.createdDate) {
        data['Created Date'] = jd.postingDate;
      }
      // if (visibleColumns.validUntil) {
      //   data['Valid Until'] = jd.linkexpiry;
      // }
      if (visibleColumns.experienceRange) {
        data['Experience Range'] =
          jd.description &&
          jd.description.minExp !== undefined &&
          jd.description.maxExp !== undefined
            ? `${jd.description.minExp} - ${jd.description.maxExp} yrs`
            : '0-1 yrs';
      }
      if (visibleColumns.action) {
        data['Status'] = jobStatuses[jd.jd_id] || jd.jd_status || 'Active';
      }
      return data;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Job Descriptions');

    const wscols = [];
    if (visibleColumns.jobRole) wscols.push({ wch: 30 });
    if (visibleColumns.jobType) wscols.push({ wch: 15 });
    if (visibleColumns.createdDate) wscols.push({ wch: 15 });
    if (visibleColumns.experienceRange) wscols.push({ wch: 20 });
    if (visibleColumns.action) wscols.push({ wch: 15 });
    worksheet['!cols'] = wscols;

    XLSX.writeFile(
      workbook,
      `Job_Descriptions_${new Date().toISOString().split('T')[0]}.xlsx`,
    );
  };

  const handleColumnToggle = (column) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  const handleSelectAllColumns = () => {
    setVisibleColumns({
      createdDate: true,
      jobRole: true,
      jobType: true,
      experienceRange: true,
      // validUntil: true,
      action: true,
    });
  };

  const handleUnselectAllColumns = () => {
    setVisibleColumns({
      createdDate: false,
      jobRole: false,
      jobType: false,
      experienceRange: false,
      // validUntil: false,
      action: false,
    });
  };

  const handleSortJobRole = () => {
    setSortOrder((prev) => {
      if (prev === null) return 'A-Z';
      if (prev === 'A-Z') return 'Z-A';
      return null;
    });
  };

  const handleInviteCandidate = async (job) => {
    setSelectedJobForInvite(job);
    setIsGeneratingLink(true);
    setShowInviteModal(true);

    try {
      const responseData = await generateShareableLinkService(job.jd_id, job.jobrole);

      const token = responseData.link_token;
      const loc = window.location;
      // const isLocalhost = loc.hostname === 'localhost' || loc.hostname === '127.0.0.1';
      // const shareableUrl = (atsSubdomain && !isLocalhost)
      const shareableUrl = atsSubdomain
        ? `${loc.protocol}//${atsSubdomain}.${loc.host}/apply/${token}`
        : `${loc.origin}/apply/${token}`;
      // if (isLocalhost) console.log('[ATS] Subdomain:', atsSubdomain, '| Link:', shareableUrl);

      setShareableLink(shareableUrl);
      setLinkExpiryDate(responseData.expires_at);
      setQrCodeDataUrl(await QRCode.toDataURL(shareableUrl, QR_CODE_OPTIONS));

      if (responseData.status_changed) {
        setJobStatuses((prev) => ({
          ...prev,
          [job.jd_id]: 'Active',
        }));
        toast.success(
          `Link created! Job status changed from "${responseData.original_status}" to "Active" to enable applications.`,
        );
      }
    } catch (error) {
      console.error('Error generating shareable link:', error);
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail || 'Unknown error';
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem('accessToken');
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    } finally {
      setIsGeneratingLink(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareableLink);
    setIsCopied(true);
    setTimeout(() => {
      setShowInviteModal(false);
      setIsCopied(false);
    }, 1500);
  };

  const closeInviteModal = () => {
    setShowInviteModal(false);
    setSelectedJobForInvite(null);
    setShareableLink('');
    setLinkExpiryDate(null);
    setQrCodeDataUrl('');
  };

  const triggerDownload = (dataUrl, filename) => {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const loadImage = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });

  // Wraps text to fit maxWidth, drawing each line at (x, startY) per ctx.textAlign, advancing by lineHeight.
  const drawWrappedText = (ctx, text, x, startY, maxWidth, lineHeight) => {
    const words = text.split(' ');
    let line = '';
    let y = startY;
    words.forEach((word) => {
      const testLine = line ? `${line} ${word}` : word;
      if (ctx.measureText(testLine).width > maxWidth && line) {
        ctx.fillText(line, x, y);
        line = word;
        y += lineHeight;
      } else {
        line = testLine;
      }
    });
    if (line) ctx.fillText(line, x, y);
    return y;
  };

  // Composites a shareable landscape banner (both dignitary photos on the left,
  // event/job info in the middle, QR on the right) for the one org this job-fair
  // intro is enabled for. Every other org keeps the plain QR download below —
  // this never runs for them. 1200×630 doubles as a standard link-preview size,
  // so it also renders cleanly when shared on mobile (WhatsApp, etc).
  const downloadJobFairFlyer = async () => {
    const canvas = document.createElement('canvas');
    const W = 1200;
    const H = 630;
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext('2d');

    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#1569c4';
    ctx.fillRect(0, 0, 10, H);

    try {
      const [photo1, photo2, qrImg] = await Promise.all([
        loadImage(JOB_FAIR_CONFIG.people[0].photo),
        loadImage(JOB_FAIR_CONFIG.people[1].photo),
        loadImage(qrCodeDataUrl),
      ]);

      // ── Left third: photos ──────────────────────────────────────────
      const drawPersonPhoto = (img, cx, cy, r) => {
        ctx.save();
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.closePath();
        ctx.strokeStyle = '#C7D9EF';
        ctx.lineWidth = 5;
        ctx.stroke();
        ctx.clip();
        ctx.drawImage(img, cx - r, cy - r, r * 2, r * 2);
        ctx.restore();
      };

      // Stacked (not side-by-side) so each long title has a full 360px to wrap into.
      const personR = 45;
      const personCX = 210;
      const personCYs = [180, 440];
      [photo1, photo2].forEach((img, i) => drawPersonPhoto(img, personCX, personCYs[i], personR));

      ctx.textAlign = 'center';
      ctx.fillStyle = '#111827';
      ctx.font = 'bold 15px Arial';
      JOB_FAIR_CONFIG.people.forEach((person, i) => {
        ctx.fillText(person.name, personCX, personCYs[i] + personR + 22);
      });
      ctx.fillStyle = '#6B7280';
      ctx.font = '11px Arial';
      JOB_FAIR_CONFIG.people.forEach((person, i) => {
        drawWrappedText(ctx, person.title, personCX, personCYs[i] + personR + 40, 360, 14);
      });

      ctx.strokeStyle = '#E5E7EB';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(420, 60);
      ctx.lineTo(420, H - 60);
      ctx.stroke();

      // ── Middle third: event + job info ──────────────────────────────
      const midX = 440;
      ctx.textAlign = 'left';
      ctx.fillStyle = '#1569c4';
      ctx.font = 'bold 13px Arial';
      ctx.fillText(`${JOB_FAIR_CONFIG.eventName.toUpperCase()} — ${JOB_FAIR_CONFIG.eventRegion.toUpperCase()}`, midX, H / 2 - 90);
      ctx.fillStyle = '#9CA3AF';
      ctx.font = '11px Arial';
      ctx.fillText(`${JOB_FAIR_CONFIG.eventNameMarathi} · ${JOB_FAIR_CONFIG.eventDate}`, midX, H / 2 - 70);

      ctx.fillStyle = '#111827';
      ctx.font = 'bold 30px Arial';
      drawWrappedText(ctx, selectedJobForInvite?.jobrole || 'Job Opening', midX, H / 2 - 25, 380, 36);
      ctx.textAlign = 'left';

      ctx.fillStyle = '#6B7280';
      ctx.font = '13px Arial';
      drawWrappedText(ctx, `An initiative by the ${JOB_FAIR_CONFIG.department}`, midX, H / 2 + 30, 380, 18);
      ctx.textAlign = 'left';

      ctx.fillStyle = '#9CA3AF';
      ctx.font = '11px Arial';
      ctx.fillText('Powered by GenieHire', midX, H - 60);

      ctx.strokeStyle = '#E5E7EB';
      ctx.beginPath();
      ctx.moveTo(860, 60);
      ctx.lineTo(860, H - 60);
      ctx.stroke();

      // ── Right third: QR ─────────────────────────────────────────────
      const qrSize = 200;
      const qrX = 900 + (W - 60 - 900 - qrSize) / 2;
      const qrY = H / 2 - qrSize / 2 - 15;
      ctx.fillStyle = '#FFFFFF';
      ctx.strokeStyle = '#E5E7EB';
      ctx.lineWidth = 1;
      ctx.fillRect(qrX - 8, qrY - 8, qrSize + 16, qrSize + 16);
      ctx.strokeRect(qrX - 8, qrY - 8, qrSize + 16, qrSize + 16);
      ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

      ctx.textAlign = 'center';
      ctx.fillStyle = '#111827';
      ctx.font = 'bold 14px Arial';
      ctx.fillText('Scan to Apply', qrX + qrSize / 2, qrY + qrSize + 30);

      triggerDownload(canvas.toDataURL('image/png'), `${selectedJobForInvite?.jobrole || 'job'}-rozgar-mahakumbh-flyer.png`);
    } catch (error) {
      console.error('Error generating job fair flyer:', error);
      toast.error('Could not generate the flyer image. Downloading the plain QR instead.');
      triggerDownload(qrCodeDataUrl, `${selectedJobForInvite?.jobrole || 'job'}-application-qr.png`);
    }
  };

  const downloadQRCode = () => {
    if (!qrCodeDataUrl) return;
    if (jobFairIntroEnabled) {
      downloadJobFairFlyer();
      return;
    }
    triggerDownload(qrCodeDataUrl, `${selectedJobForInvite?.jobrole || 'job'}-application-qr.png`);
  };

  const formatExpiryDate = (isoString) => {
    if (!isoString) return 'Not available';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleEditJd = async (jd) => {
    if (portal === 'org-admin') {
      if (jd.jobDescriptionType === 'customized') {
        navigate(
          `/org-admin/create-jd-custom?id=${jd.jd_id}&mode=builder&isEditFlow=true`,
        );
      } else {
        navigate('/org-admin/create-jd-smart', {
          state: {
            jd_id: jd.jd_id,
            mode: 'view-rounds',
            isEditFlow: true,
          },
        });
      }
    } else if (portal === 'hr') {
      // HR users navigate to edit page but in read-only mode
      if (jd.jobDescriptionType === 'customized') {
        navigate(
          `/hr/create-jd-custom?id=${jd.jd_id}&mode=builder&readonly=true`,
        );
      } else {
        navigate('/hr/create-jd-smart', {
          state: {
            jd_id: jd.jd_id,
            jobRole: jd.jobrole,
            mode: 'view-rounds',
            readonly: true, // Add readonly flag for HR
          },
        });
      }
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div
        className="min-h-screen flex flex-col border rounded-2xl border-gray-700/50 dark:glass-effect bg-bgSecondary"
        ref={topRef}
      >
        <style>{calendarOverrideStyles(theme)}</style>
        {/* {showEditJDForm && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-5 backdrop-blur-xl z-50 p-4">
            <div className="p-6 bg-gradient-to-br from-[#22346140] to-[#0b0a1f0d] rounded-lg shadow-lg backdrop-blur-[500px] w-full max-w-3xl max-h-[90vh] overflow-y-auto relative">
              <div className="flex justify-between items-center mb-4">
                <button
                  onClick={() => setShowEditJDForm(false)}
                  className="hover:text-opacity-80 dark:text-white text-textSecondary"
                >
                  ✖
                </button>
                <button
                  onClick={() => handleUploadResume(jd_id)}
                  className="flex items-center gap-2 text-white bg-blue-500 hover:bg-blue-600 px-3 py-2.5 rounded-full text-sm"
                >
                  <Upload className="w-4 h-4" />
                  Upload Resume
                </button>
              </div>
              <div className="p-6 space-y-6">
                {jobdesc && <div>{formatJobDescription(jobRole, jobdesc)}</div>}
              </div>
            </div>
          </div>
        )} */}
        <div className="flex flex-col flex-1 w-full justify-center items-center">
          <div
            className="table-container flex-1 w-full"
            style={{
              transform: 'translateZ(0)',
              backfaceVisibility: 'hidden',
              contain: 'layout',
            }}
          >
            <div className="table-header px-6">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 py-4 mb-4">
                <div className="flex items-center gap-4">
                  <h1 className="text-xl dark:text-[#D9D9D9] text-textPrimary font-normal text-left pl-6">
                    Job Roles
                  </h1>
                </div>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-4">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder=" Search by Job Role"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className={`w-56  ${theme === 'dark' ? 'glass-effect text-[#EDEDEDE5]' : 'bg-bgPrimary !text-textPrimary'}  border border-gray-600 rounded-full pl-10 pr-4   placeholder-gray-500 focus:outline-none focus:border-gray-400 dark:focus:border-white text-sm h-10 placeholder:text-sm`}
                    />
                    {searchQuery && (
                      <button
                        onClick={() => setSearchQuery('')}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
                      >
                        <XIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-textPrimary cursor-pointer" />
                      </button>
                    )}
                  </div>
                  {portal === 'org-admin' && (
                    <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
                      <button
                        onClick={handleAddJD}
                        className="button flex items-center justify-center gap-2 w-full sm:w-auto"
                      >
                        <span className="flex gap-2">
                          <PlusCircle className="w-5 h-5" />
                          <span className="hidden sm:inline">Create Job Role</span>
                          <span className="sm:hidden">Create JD</span>
                        </span>
                      </button>
                    </div>
                  )}

                  <div className="relative" ref={filterRef}>
                    <button
                      className={`flex items-center space-x-4 ${theme === 'dark' ? 'glass-effect ' : 'bg-bgPrimary'} border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-50 text-sm font-light`}
                      onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                    >
                      <SlidersHorizontal className="w-4 h-4" />
                      <span>Filter</span>
                      {filterCount > 0 && (
                        <>
                          <span className="ml-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs absolute -right-2 -top-1">
                            {filterCount}
                          </span>
                          <XCircleIcon
                            className="w-5 h-5"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleResetFilter();
                            }}
                          />
                        </>
                      )}
                    </button>
                    {showFilterDropdown && (
                      <div className="absolute right-0 mt-2 w-[400px] border border-gray-600 rounded-lg shadow-lg z-20 p-6 dark:bg-[linear-gradient(233.57deg,rgba(34,52,97,0.25)_-5.01%,rgba(11,10,31,0.05)_100%)] bg-bgPrimary dark:backdrop-blur-[500px] opacity-100">
                        <div className="flex items-center justify-between mb-4">
                          <h3 className="text-lg font-medium dark:text-[#D9D9D9] text-textPrimary">
                            Filter
                          </h3>
                          <button
                            onClick={() => setShowFilterDropdown(false)}
                            className="dark:text-gray-400 dark:hover:text-white text-textPrimary hover:text-textSecondary"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        {activeFilters.length > 0 && (
                          <div className="mb-4">
                            <div className="flex items-center justify-between mb-2">
                              <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                                Active Filters
                              </label>
                              <button
                                onClick={handleResetFilter}
                                className="text-xs text-blue-400 hover:text-blue-300"
                              >
                                Clear All
                              </button>
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {activeFilters.map((filter, index) => (
                                <div
                                  key={index}
                                  className="flex items-center dark:bg-gray-700/50 bg-violet-600 dark:text-[#D9D9D9] text-xs px-3 py-1 rounded-full dark:border-green-400 border border-violet-900 text-white"
                                >
                                  <span>{filter.label}</span>
                                  <button
                                    onClick={filter.onRemove}
                                    className="ml-2 dark:text-gray-400 hover:text-white text-gray-200"
                                  >
                                    <XCircleIcon className="w-4 h-4" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {/* Job Type Filter */}
                        <div className="mb-6">
                          <div className="flex items-center justify-between mb-2">
                            <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                              Job Type
                            </label>
                            <button
                              onClick={handleResetJobType}
                              className="text-xs text-blue-400 hover:text-blue-300"
                            >
                              Reset
                            </button>
                          </div>
                          <div className="relative">
                            <select
                              value={tempJobTypeFilter}
                              onChange={(e) =>
                                setTempJobTypeFilter(e.target.value)
                              }
                              className="
                                w-full
                                border border-gray-600
                                rounded-full
                                px-4 py-2
                                bg-bgPrimary dark:bg-glass-effect
                                text-textSecondary dark:text-gray-300
                                text-sm
                                focus:outline-none
                                appearance-none
                                hover:bg-gray-50 dark:hover:bg-gray-700/50
                                transition-all duration-200
                              "
                            >
                              <option
                                value="All"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                All
                              </option>
                              <option
                                value="Smart Mode"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                Smart Mode
                              </option>
                              <option
                                value="Custom Mode"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                Custom Mode
                              </option>
                            </select>

                            {/* Icon */}
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-4 h-4 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                        {/* Date Range Filter */}
                        <div className="mb-6">
                          <div className="flex items-center justify-between mb-2">
                            <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                              Date Range
                            </label>
                            <button
                              onClick={handleResetDateRange}
                              className="text-xs text-blue-400 hover:text-blue-300"
                            >
                              Reset
                            </button>
                          </div>
                          <div className="relative" ref={calendarRef}>
                            <button
                              className="flex items-center justify-between w-full dark:glass-effect bg-bgPrimary border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-50 text-sm font-light h-10"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsCalendarOpen(!isCalendarOpen);
                              }}
                              aria-expanded={isCalendarOpen}
                            >
                              <span className="truncate">
                                {formatDateRange(tempDateRange)}
                              </span>
                              {tempDateRange?.length === 2 && tempDateRange[0] ? (
                                <X
                                  className="w-4 h-4"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTempDateRange([null, null]);
                                    setIsCalendarOpen(false);
                                  }}
                                />
                              ) : (
                                <ChevronDown className="w-4 h-4" />
                              )}
                            </button>
                            {isCalendarOpen && (
                              <div
                                className="candidate-analytics-calendar absolute mt-2 z-[100] right-0"
                                style={{
                                  background: theme === 'dark' ? "#0a1733" : "#fff",
                                  border: "1px solid #4b5563",
                                  borderRadius: "8px"
                                }}
                              >
                                <div className={`platform-calendar ${theme}`}>
                                  <PlatformCalendar
                                    onChange={(value) => {
                                      setTempDateRange(value);
                                      if (value[0] && value[1]) {
                                        setIsCalendarOpen(false);
                                      }
                                    }}
                                    value={tempDateRange}
                                    selectRange={true}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Status Filter */}
                        <div className="mb-6">
                          <div className="flex items-center justify-between mb-2">
                            <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                              Status
                            </label>
                            <button
                              onClick={handleResetStatus}
                              className="text-xs text-blue-400 hover:text-blue-300"
                            >
                              Reset
                            </button>
                          </div>
                          <div className="relative">
                            <select
                              value={tempStatusFilter}
                              onChange={(e) =>
                                handleStatusSelect(e.target.value)
                              }
                              className="
                                w-full 
                                border border-gray-600 
                                rounded-full 
                                px-4 py-2 
                                bg-bgPrimary dark:bg-glass-effect 
                                text-textSecondary dark:text-gray-300 
                                text-sm 
                                focus:outline-none 
                                focus:border-gray-400 
                                appearance-none 
                                hover:bg-gray-50 dark:hover:bg-gray-700/50
                                transition-colors
                              "
                            >
                              <option
                                value="All"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                All ({statusCounts.All})
                              </option>
                              <option
                                value="Active"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                Active ({statusCounts.Active})
                              </option>
                              <option
                                value="On Hold"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                On Hold ({statusCounts['On Hold']})
                              </option>
                              <option
                                value="Closed"
                                className="dark:bg-[#0a1733] bg-bgPrimary"
                              >
                                Closed ({statusCounts.Closed})
                              </option>
                            </select>

                            {/* Icon */}
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-4 h-4 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                        {/* Experience Range Filter */}
                        <div className="mb-6">
                          <div className="flex items-center justify-between mb-2">
                            <label className="text-sm font-medium dark:text-[#D8D8D8] text-textSecondary">
                              Experience Range (Years)
                            </label>
                            <button
                              onClick={handleResetExpRange}
                              className="text-xs text-blue-400 hover:text-blue-300"
                            >
                              Reset
                            </button>
                          </div>
                          <div className="flex space-x-2">
                            <input
                              type="number"
                              className={`w-full ${theme === 'dark' ? 'focus:border-white glass-effect text-[#EDEDEDE5]' : 'bg-bgPrimary !text-textPrimary border-gray-200 focus:border-gray-300'} border border-gray-600 rounded-full px-3 !py-[5px]  text-sm focus:outline-none placeholder:text-sm `}
                              placeholder="Min Exp"
                              value={tempExpRange.min}
                              onChange={(e) => handleExpRangeChange(e, 'min')}
                              min="0"
                            />
                            <input
                              type="number"
                              className={`w-full ${theme === 'dark' ? 'focus:border-white glass-effect text-[#EDEDEDE5]' : 'bg-bgPrimary !text-textPrimary border-gray-200 focus:border-gray-300'} border border-gray-600 rounded-full px-3 !py-[5px]   text-sm focus:outline-none placeholder:text-sm `}
                              placeholder="Max Exp"
                              value={tempExpRange.max}
                              onChange={(e) => handleExpRangeChange(e, 'max')}
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="flex space-x-3">
                          <button
                            onClick={handleResetFilter}
                            className="flex-1 px-4 py-2 border border-gray-600 rounded-full dark:text-gray-300 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-200 text-sm"
                          >
                            Reset All
                          </button>
                          <button
                            onClick={handleApplyFilters}
                            className="flex-1 px-4 py-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-sm hover:opacity-90"
                          >
                            Apply Now
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="relative" ref={columnSelectorRef}>
                    {/* Removed For Deployment */}
                    {/* <button
                      className="flex items-center space-x-4 dark:glass-effect bg-bgPrimary border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-50 text-sm font-light"
                      onClick={() => setShowColumnSelector(!showColumnSelector)}
                    >
                      <Layout className="w-4 h-4" />
                      <span>Columns</span>
                      {(!visibleColumns.createdDate ||
                        !visibleColumns.jobRole ||
                        !visibleColumns.experienceRange ||
                        !visibleColumns.action) && (
                        <XCircleIcon
                          className="w-5 h-5"
                          onClick={() =>
                            setVisibleColumns({
                              createdDate: true,
                              jobRole: true,
                              experienceRange: true,
                              action: true,
                            })
                          }
                        />
                      )}
                    </button> */}
                    {showColumnSelector && (
                      <div
                        className="absolute right-0 mt-2 w-60 border border-gray-600 rounded-lg shadow-lg z-20 p-6 bg-bgPrimary"
                        style={{
                          background: `${theme === 'dark' ? 'linear-gradient(233.57deg, rgba(34, 52, 97, 0.25) -5.01%, rgba(11, 10, 31, 0.05) 100%)' : ''}`,
                          opacity: 1,
                          backdropFilter: 'blur(500px)',
                        }}
                      >
                        <div className="flex items-center justify-between mb-4">
                          <h3 className="text-lg font-medium dark:text-[#D9D9D9] text-textPrimary">
                            Select Columns
                          </h3>
                          <button
                            onClick={() => setShowColumnSelector(false)}
                            className="dark:text-gray-400 text-textSecondary dark:hover:text-white hover:text-gray-400"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        <div className="flex space-x-3 mb-4">
                          <button
                            onClick={handleSelectAllColumns}
                            className="flex-1 px-2 py-1 bg-gradient-to-r from-pink-500 to-blue-500 text-white rounded-full text-xs hover:opacity-90"
                          >
                            Select All
                          </button>
                          {/* <button
                            onClick={handleUnselectAllColumns}
                            className="flex-1 px-2 py-1 border border-gray-600 rounded-full dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-200 text-xs"
                          >
                            Unselect All
                          </button> */}
                        </div>
                        <div className="space-y-2">
                          {Object.keys(visibleColumns).map((column) => (
                            <div key={column} className="flex items-center">
                              <input
                                type="checkbox"
                                checked={visibleColumns[column]}
                                onChange={() => handleColumnToggle(column)}
                                className="mr-2 h-4 w-4 accent-blue-600"
                              />
                              <label className="text-sm dark:text-[#D8D8D8] text-textSecondary">
                                {column
                                  .replace(/([A-Z])/g, ' $1')
                                  .replace(/^./, (str) => str.toUpperCase())}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="relative group flex items-center">
                    <button
                      className="flex items-center space-x-4 dark:glass-effect bg-bgPrimary border border-gray-600 rounded-full px-4 py-2 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-50 text-sm font-light"
                      onClick={handleDownloadExcel}
                    >
                      <Download className="w-4 h-4" />
                      <span>Download Excel</span>
                    </button>
                  </div>
                  <button
                    onClick={() => setIsHelpVideoOpen(true)}
                    className="w-6 h-6 rounded-full border flex items-center justify-center flex-shrink-0 dark:border-gray-400 border-gray-500 dark:text-gray-400 text-gray-500 text-xs font-semibold hover:opacity-80 transition-opacity"
                    title="Help"
                  >
                    ?
                  </button>
                </div>
              </div>
              <div className="w-full overflow-hidden flex flex-col flex-1 min-h-0">
                <div className="w-full flex-1 overflow-y-auto pb-32 min-h-[400px]">
                  <Table
                    className="w-full"
                    style={{
                      transform: 'translateZ(0)',
                      contain: 'layout',
                    }}
                  >
                      <Thead className="border-b border-t border-[#5A4479D4]">
                        <Tr>
                          {visibleColumns.jobRole && (
                            <Th className="text-left min-w-0 ">
                              <div className="flex items-center dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                                Job Role
                                <button
                                  onClick={handleSortJobRole}
                                  className="ml-2 focus:outline-none"
                                >
                                  {sortOrder === 'A-Z' ? (
                                    <ArrowUpAZ className="w-4 h-4 dark:text-gray-300 text-textSecondary" />
                                  ) : sortOrder === 'Z-A' ? (
                                    <ArrowDownZA className="w-4 h-4 dark:text-gray-300 text-textSecondary" />
                                  ) : (
                                    <ArrowUpDown className="w-4 h-4 dark:text-gray-300 text-textSecondary" />
                                  )}
                                </button>
                              </div>
                            </Th>
                          )}
                          {visibleColumns.jobType && (
                            <Th className="text-left min-w-0">
                              <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                                Job Type
                              </span>
                            </Th>
                          )}
                          {visibleColumns.createdDate && (
                            <Th className="text-left min-w-0">
                              <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                                Created On
                              </span>
                            </Th>
                          )}
                          {visibleColumns.experienceRange && (
                            <Th className="text-left min-w-0 hidden sm:table-cell">
                              <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                                Experience Range
                              </span>
                            </Th>
                          )}
                          {/* {visibleColumns.validUntil && (
                            <Th className="text-left min-w-0">
                              <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                                Valid Until
                              </span>
                            </Th>
                          )} */}
                          {visibleColumns.action && (
                            <Th className="text-left min-w-0">
                              <span className="dark:text-[#D8D8D8] text-textSecondary text-xs font-medium normal-case">
                                Action
                              </span>
                            </Th>
                          )}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {currentJobs.length === 0 && (
                          <Tr>
                            <Td colSpan={Object.values(visibleColumns).filter(Boolean).length}>
                              <div className="flex h-60 items-center justify-center">
                                <div className="flex flex-col items-center text-center">
                                  <h2 className="text-lg font-medium text-gray-400 mb-1">
                                    No Job Role found
                                  </h2>
                                  <p className="text-sm text-gray-400">
                                    Try adjusting your filters or search terms to see more
                                    results.
                                  </p>
                                </div>
                              </div>
                            </Td>
                          </Tr>
                        )}
                        {currentJobs.map((jd) => (
                          <Tr
                            key={jd.jd_id}
                            className="group dark:hover:bg-gray-700/20 hover:bg-gray-300/20 cursor-pointer"
                            onClick={() => {
                              // handleEditJd(jd)
                              handleNavigate(jd);
                            }}
                          >
                            {visibleColumns.jobRole && (
                              <Td className="text-left px-2 py-3 min-w-0">
                                <div
                                  className="whitespace-normal break-words text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm"
                                  title={jd.jobrole}
                                >
                                  {jd.jobrole}
                                </div>
                                <div className="text-xs dark:text-gray-400 text-textSecondary mt-1 sm:hidden">
                                  {visibleColumns.experienceRange &&
                                    (jd.description &&
                                    jd.description.minExp !== undefined &&
                                    jd.description.maxExp !== undefined
                                      ? `${jd.description.minExp} - ${jd.description.maxExp} yrs`
                                      : '0-1 yrs')}
                                </div>
                              </Td>
                            )}
                            {visibleColumns.jobType && (
                              <Td className="text-left px-2 py-3 min-w-0">
                                <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                                  {jd.jd_version === 'Smart Mode' ? 'Smart Mode' : jd.jd_version === 'Custom Mode' ? 'Custom Mode' : jd.jd_version}
                                </div>
                              </Td>
                            )}
                            {visibleColumns.createdDate && (
                              <Td className="text-left px-2 py-3 min-w-0">
                                <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                                  {jd.postingDate}
                                </div>
                              </Td>
                            )}
                            {visibleColumns.experienceRange && (
                              <Td className="text-left px-2 py-3 hidden sm:table-cell min-w-0">
                                <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                                  {jd.description &&
                                  jd.description.minExp !== undefined &&
                                  jd.description.maxExp !== undefined
                                    ? jd.description.minExp === 0 &&
                                      jd.description.maxExp === 0
                                      ? '0 yrs'
                                      : `${jd.description.minExp} - ${jd.description.maxExp} yrs`
                                    : '0-1 yrs'}
                                </div>
                              </Td>
                            )}
                            {/* {visibleColumns.validUntil && (
                              <Td className="text-left px-2 py-3 min-w-0">
                                <div className="truncate text-left px-2 dark:text-[#CCCCCCE5] text-textSecondary text-sm">
                                  {jd.linkexpiry && jd.linkexpiry !== 'NA'
                                    ? new Date(jd.linkexpiry)
                                        .toISOString()
                                        .split('T')[0]
                                    : jd.linkexpiry}
                                </div>
                              </Td>
                            )} */}
                            {visibleColumns.action && (
                              <Td
                                className="px-2 py-3 min-w-0"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex flex-col sm:flex-row items-center gap-2">
                                  <div className="relative inline-block w-full sm:w-auto">
                                    <select
                                      value={
                                        jobStatuses[jd.jd_id] ||
                                        jd.jd_status ||
                                        'Active'
                                      }
                                      onChange={(e) =>
                                        updateJobStatus(
                                          jd.jd_id,
                                          e.target.value,
                                        )
                                      }
                                      className={`appearance-none rounded-full px-8 py-1.5 text-xs sm:text-sm font-medium border cursor-pointer focus:outline-none transition-all duration-200 dark:shadow-md shadow-sm bg-transparent w-full sm:w-auto ${
                                        (jobStatuses[jd.jd_id] ||
                                          jd.jd_status ||
                                          'Active') === 'Closed'
                                          ? 'text-[#DC0000] border-[#DC0000]'
                                          : (jobStatuses[jd.jd_id] ||
                                                jd.jd_status ||
                                                'Active') === 'On Hold'
                                            ? 'text-[#D39C1D] border-[#D39C1D]'
                                            : 'text-[#069855] border-[#069855]'
                                      }`}
                                    >
                                      <option
                                        value="Active"
                                        className="dark:text-gray-700 dark:glass-effect text-textSecondary font-medium"
                                      >
                                        Active
                                      </option>
                                      <option
                                        value="On Hold"
                                        className=" dark:text-gray-700 text-textSecondary font-medium"
                                      >
                                        On Hold
                                      </option>
                                      <option
                                        value="Closed"
                                        className=" dark:text-gray-700 text-textSecondary font-medium"
                                      >
                                        Closed
                                      </option>
                                    </select>
                                    <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                                      <svg
                                        className={`w-3 h-3 sm:w-4 sm:h-4 ${
                                          (jobStatuses[jd.jd_id] ||
                                            jd.jd_status ||
                                            'Active') === 'Closed'
                                            ? 'text-[#DC0000]'
                                            : (jobStatuses[jd.jd_id] ||
                                                  jd.jd_status ||
                                                  'Active') === 'On Hold'
                                              ? 'text-[#D39C1D]'
                                              : 'text-[#069855]'
                                        }`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M19 9l-7 7-7-7"
                                        ></path>
                                      </svg>
                                    </div>
                                  </div>
                                <div className={`relative flex justify-center ${activeDropdown === jd.jd_id ? 'z-[60]' : ''}`}>
                                    <button
                                      id={`dropdown-button-${jd.jd_id}`}
                                      className="p-2 rounded-full focus:outline-none group dropdown-button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleDropdown(jd.jd_id);
                                      }}
                                    >
                                      <MoreVertical className="w-5 h-5 ml-4 dark:text-[#CCCCCCE5] text-textSecondary" />
                                      {activeDropdown === jd.jd_id && (
                                        <div
                                          id={`dropdown-menu-${jd.jd_id}`}
                                          className={`absolute w-34 sm:w-38 dark:bg-gray-800 bg-white border border-gray-200 dark:border-gray-700 rounded-md shadow-lg z-50 dropdown-menu -mr-7 ${dropdownMenuDirection[jd.jd_id] === 'up' ? 'bottom-full mb-2' : 'top-0 mt-6'} right-full`}
                                        >
                                          <div className="py-1 dark:text-gray-300 text-gray-700">
                                            {portal === 'org-admin' && (
                                              <button
                                                onClick={(e) =>
                                                  handleEditJd(jd)
                                                }
                                                className="block w-full text-left px-4 py-2 text-sm dark:hover:bg-gray-700 hover:bg-gray-200 transition-colors"
                                              >
                                                Edit Jd
                                              </button>
                                            )}
                                            {atsEnabled ? (
                                              <button
                                                onClick={() =>
                                                  handleInviteCandidate(jd)
                                                }
                                                className="block w-full text-left px-4 py-2 text-sm dark:hover:bg-gray-700 hover:bg-gray-200 transition-colors"
                                              >
                                                Invite Candidate
                                              </button>
                                            ) : (
                                              <div className="relative group/tooltip">
                                                <button
                                                  disabled
                                                  className="flex items-center gap-1.5 w-full text-left px-3 py-2 text-sm text-gray-400"
                                                  title="This feature is not part of your plan"
                                                >
                                                  <svg
                                                    className="w-3.5 h-3.5 shrink-0"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  >
                                                    <rect
                                                      x="3"
                                                      y="11"
                                                      width="18"
                                                      height="11"
                                                      rx="2"
                                                    />
                                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                                  </svg>
                                                  Invite Candidate
                                                </button>
                                              </div>
                                            )}
                                            {portal === 'org-admin' && (
                                              <button
                                                onClick={(e) =>
                                                  handleDeleteConfirmation(
                                                    e,
                                                    jd,
                                                  )
                                                }
                                                className="block w-full text-left px-4 py-2 text-sm dark:hover:bg-gray-700 hover:bg-gray-200 transition-colors"
                                              >
                                                Delete
                                              </button>
                                            )}
                                            {jd.selectedServices &&
                                              (jd.selectedServices[
                                                'sourcing'
                                              ] ||
                                                jd.selectedServices[
                                                  'screening'
                                                ]) && (
                                                <button
                                                  onClick={() =>
                                                    handleViewCandidates(
                                                      jd.jd_id,
                                                      jd.selectedServices,
                                                      jd.jobrole,
                                                    )
                                                  }
                                                  className="block w-full text-left px-4 py-2 text-sm dark:hover:bg-gray-700 hover:bg-gray-200 transition-colors"
                                                >
                                                  Candidates
                                                </button>
                                              )}
                                          </div>
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </Td>
                            )}
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                </div>
                    <Pagination
                      currentPage={currentPage}
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      onPageChange={handlePageChange}
                      onItemsPerPageChange={(size) => {
                        setItemsPerPage(size);
                        setCurrentPage(1);
                        setSearchParams({ page: '1' });
                      }}
                      label="Jobs"
                    />
              </div>
            </div>
          </div>
        </div>

        {/* Footer with Glass Effect */}
        {/* <footer className={`py-4 px-8 border-t border-gray-700/50 mt-auto dark:glass-effect bg-bgSecondary/80 backdrop-blur-md text-center sticky bottom-0 z-10 rounded-b-2xl`}>
          <p className="text-sm dark:text-gray-400 text-textSecondary font-light">
            © {new Date().getFullYear()} GenieHire. All rights reserved.
          </p>
        </footer> */}

        {showInviteModal && (
          <div className="fixed inset-0 flex items-center justify-center dark:bg-black/60 bg-bgPrimary/80  backdrop-blur-sm z-50">
            <div className="p-6 dark:bg-gradient-to-br bg-bgPrimary from-[#22346140] to-[#0b0a1f0d] rounded-lg shadow-2xl backdrop-blur-[500px] w-full max-w-xl relative border border-gray-700 ">
              <div className="flex justify-between items-center mb-4">
                <h3 className="dark:text-[#C1A0D0] text-textPrimary text-lg font-medium">
                  Invite Candidate
                </h3>
                <button
                  onClick={closeInviteModal}
                  className="hover:text-opacity-80 dark:text-white text-textSecondary"
                >
                  <CircleX className="w-5 h-5" />
                </button>
              </div>

              {selectedJobForInvite && (
                <div className="mb-4">
                  <p className="dark:text-white text-textPrimary text-sm mb-2">
                    Job Role :{' '}
                    <span className="dark:text-white text-textPrimary tracking-wider">
                      {selectedJobForInvite.jobrole}
                    </span>
                  </p>
                </div>
              )}
              <div className="flex items-center space-x-2 mb-6 text-sm">
                <span className="dark:text-white text-textPrimary">
                  Link expires:
                </span>
                <span className=" dark:text-white text-textSecondary">
                  {formatExpiryDate(linkExpiryDate)}
                </span>
              </div>
              {shareableLink ? (
                <div className="space-y-4">
                  <div className="flex items-center gap-4">
                    <input
                      type="text"
                      value={shareableLink}
                      readOnly
                      className="w-2/3 bg-transparent border border-gray-600 dark:text-white text-textSecondary px-4 py-2 rounded-full text-sm"
                    />
                    <button
                      onClick={copyToClipboard}
                      className={`px-4 py-2 rounded-full text-sm transition-opacity w-1/3 ${isCopied ? 'border-btn !text-textPrimary' : 'bg-gradient-to-r from-pink-500 to-blue-500 text-white hover:opacity-90'}`}
                    >
                      {isCopied ? 'Copied' : 'Copy'}
                    </button>
                  </div>
                  {/* {qrCodeDataUrl && (
                    <div className="flex flex-col items-center gap-3 pt-4 mt-1 border-t border-gray-600/50">
                      <p className="text-xs font-medium uppercase tracking-wide dark:text-white text-textSecondary">
                        Scan to Apply
                      </p>
                      <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-200">
                        <img
                          src={qrCodeDataUrl}
                          alt="Job application QR code"
                          className="w-32 h-32"
                        />
                      </div>
                      <button
                        onClick={downloadQRCode}
                        className="flex items-center gap-2 px-4 py-2 rounded-full text-sm border border-gray-600 dark:text-white text-textPrimary hover:bg-gray-700/50 transition-colors"
                      >
                        <Download className="w-4 h-4" />
                        Download QR
                      </button>
                    </div>
                  )} */}
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        )}

        {showJDViewModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-5 backdrop-blur-xl z-50 p-4">
            <div className="p-6 bg-gradient-to-br from-[#22346140] to-[#0b0a1f0d] rounded-lg shadow-lg backdrop-blur-[500px] w-full max-w-4xl max-h-[90vh] overflow-y-auto relative">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl text-[#C1A0D0] font-medium">
                  {selectedJDForView
                    ? `Job Description - ${selectedJDForView.jobrole}`
                    : 'Loading...'}
                </h3>
                <button
                  onClick={() => {
                    setShowJDViewModal(false);
                    setSelectedJDForView(null);
                    setIsLoadingJDDetails(false);
                  }}
                  className="hover:text-opacity-80 text-white"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {isLoadingJDDetails ? (
                <div className="flex justify-center items-center h-60">
                  <Loader />
                </div>
              ) : selectedJDForView ? (
                <>
                  <div className="mb-4 flex flex-wrap gap-4 text-sm">
                    <div className="text-gray-300">
                      <span className="text-gray-400">Created:</span>{' '}
                      {selectedJDForView.postingDate}
                    </div>
                    <div className="text-gray-300">
                      <span className="text-gray-400">Status:</span>
                      <span
                        className={`ml-1 px-2 py-1 rounded-full text-xs ${
                          (jobStatuses[selectedJDForView.jd_id] ||
                            selectedJDForView.jd_status ||
                            'Active') === 'Closed'
                            ? 'text-red-400 bg-red-400/20'
                            : (jobStatuses[selectedJDForView.jd_id] ||
                                  selectedJDForView.jd_status ||
                                  'Active') === 'On Hold'
                              ? 'text-yellow-400 bg-yellow-400/20'
                              : 'text-green-400 bg-green-400/20'
                        }`}
                      >
                        {jobStatuses[selectedJDForView.jd_id] ||
                          selectedJDForView.jd_status ||
                          'Active'}
                      </span>
                    </div>
                    <div className="text-gray-300">
                      <span className="text-gray-400">Experience:</span>
                      {selectedJDForView.description &&
                      selectedJDForView.description.minExp !== undefined &&
                      selectedJDForView.description.maxExp !== undefined
                        ? ` ${selectedJDForView.description.minExp} - ${selectedJDForView.description.maxExp} yrs`
                        : ' 0-1 yrs'}
                    </div>
                  </div>

                  <div className="space-y-6">
                    {selectedJDForView.description && (
                      <div>
                        {formatJobDescription(
                          selectedJDForView.jobrole,
                          selectedJDForView.description,
                        )}
                      </div>
                    )}
                  </div>

                  <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-600">
                    <button
                      onClick={() => handleInviteCandidate(selectedJDForView)}
                      className="flex items-center gap-2 bg-gradient-to-r from-pink-500 to-blue-500 text-white px-4 py-2 rounded-full text-sm hover:opacity-90"
                    >
                      Invite Candidate
                    </button>
                    <button
                      onClick={() => {
                        setShowJDViewModal(false);
                        setSelectedJDForView(null);
                        setIsLoadingJDDetails(false);
                      }}
                      className="px-4 py-2 border border-gray-600 rounded-full text-gray-300 hover:bg-gray-700/50 text-sm"
                    >
                      Close
                    </button>
                  </div>
                </>
              ) : (
                <div className="flex justify-center items-center h-40">
                  <div className="text-lg font-medium text-gray-400">No data available</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <ConfirmationDialog
        open={showDeleteConfirmDialog}
        onClose={() => {
          setShowDeleteConfirmDialog(false);
          setSelectedJDForDelete(null);
        }}
        title="Delete Job Description ?"
        message={`Are you sure you want to delete the "${selectedJDForDelete?.jobrole}" job description? This action cannot be undone`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDeleteJD}
      />
      <HelpVideoModal
        open={isHelpVideoOpen}
        onClose={() => setIsHelpVideoOpen(false)}
        videos={HELP_VIDEOS}
        defaultIndex={5}
      />
    </>
  );
};

export default CreatedJDs;
